import type { ReactNode } from 'react';
import { ClockIcon, CrossIcon, ShieldCheckIcon } from './DocumentIcons';
import styles from './Documents.module.scss';

export type PillTone = 'pending' | 'approved' | 'rejected';

function ToneIcon({ tone }: { tone: PillTone }) {
  switch (tone) {
    case 'pending':
      return <ClockIcon />;
    case 'approved':
      return <ShieldCheckIcon />;
    case 'rejected':
      return <CrossIcon />;
  }
}

export default function StatusPill({
  tone,
  className,
  children,
}: {
  tone: PillTone;
  className?: string;
  children: ReactNode;
}) {
  return (
    <span className={[styles.pill, styles[tone], className].filter(Boolean).join(' ')}>
      <ToneIcon tone={tone} />
      {children}
    </span>
  );
}
